import { SEO_BASE_URL } from "../seo/seoConfig";
import i18n from "../i18n";

export const SHARE_APP_URL = `${SEO_BASE_URL}/`;

function isAbortError(error) {
  return (
    error?.name === "AbortError" ||
    error?.name === "NotAllowedError" ||
    String(error?.message || "").toLowerCase().includes("abort")
  );
}

async function copyTextToClipboard(text) {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fall through to the textarea copy path for older or restricted browsers.
    }
  }

  if (
    typeof document === "undefined" ||
    !document.body ||
    typeof document.execCommand !== "function"
  ) {
    return false;
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.top = "-1000px";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();

  try {
    return document.execCommand("copy");
  } finally {
    document.body.removeChild(textArea);
  }
}

export async function shareAppLink(payload) {
  const sharePayload = {
    title: payload?.title || "ReelitPro",
    text:
      payload?.text ||
      i18n.t("share_app_default_text", {
        defaultValue: "Join me on ReelitPro and share your fishing adventures.",
      }),
    url: payload?.url || SHARE_APP_URL,
  };

  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share(sharePayload);
      return "shared";
    } catch (error) {
      if (isAbortError(error)) return "cancelled";
    }
  }

  const copied = await copyTextToClipboard(sharePayload.url);
  return copied ? "copied" : "unavailable";
}
